// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/OverallScore/OverallScoreBlob.scss
// module id = 1374
// module chunks = 10 21